// extracted by mini-css-extract-plugin
export var background = "Footer-module--background--nhARr";
export var footer = "Footer-module--footer--LZE0a";
export var list = "Footer-module--list--WUpjB";
export var logo = "Footer-module--logo--Lu+fA";